<template>
    <Form ref="loginForm"
        :model="form"
        :rules="rules"
        @keydown.enter.native="handleSubmit">
        <FormItem prop="userName">
            <Input v-model="form.userName"
                placeholder="请输入用户名">
            <span slot="prepend">
                <Icon :size="16"
                    type="ios-person"/>
            </span>
            </Input>
        </FormItem>
        <FormItem prop="password">
            <Input v-model="form.password"
                type="password"
                placeholder="请输入密码">
            <span slot="prepend">
                <Icon :size="14"
                    type="md-lock"/>
            </span>
            </Input>
        </FormItem>
        <FormItem>
            <Button :loading="loading"
                type="primary"
                long
                @click="handleSubmit">登录</Button>
        </FormItem>
		<FormItem style="display:flex;align-items:flex-end;justify-content:flex-end;">
			<Button style="background-color: #ffff;border: none;color: #2d8cf0;font-size: 14px;padding: 0px;" to="https://oldseedadmin.brighten.cn:4443" target="_blank" long type="primary">前往旧版</Button>
		</FormItem>
    </Form>
</template>
<script>
export default {
    name: 'LoginForm',
    props: {
        userNameRules: {
            type: Array,
            default: () => {
                return [
                    { required: true, message: '账号不能为空', trigger: 'blur' }
                ];
            }
        },
        passwordRules: {
            type: Array,
            default: () => {
                return [
                    { required: true, message: '密码不能为空', trigger: 'blur' }
                ];
            }
        },
        loading: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            form: {
                userName: '',
                password: ''
            }
        };
    },
    computed: {
        rules() {
            return {
                userName: this.userNameRules,
                password: this.passwordRules
            };
        }
    },
    methods: {
        handleSubmit() {
            this.$refs.loginForm.validate(valid => {
                if (valid) {
                    this.$emit('on-success-valid', {
                        userName: this.form.userName,
                        password: this.form.password
                    });
                }
            });
        }
    }
};
</script>
<style>
	.ivu-form-item{
		margin-bottom: 20px !important;
	}
</style>